import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SuiCheckboxGroup, SuiCheckbox, SuiTextInput } from '@splashthat/sui';

import './IncludeOtherStyles.styl';

const OTHER_LABEL = 'Other';
const baseClassName = 'CheckboxIncludeOther';

const StyledOtherOption = styled.div`
    padding: 0.5rem 0;
`;

const CheckboxIncludeOther = ({ questionLabel, ...props }) => {
    const [otherValue, setOtherValue] = useState('');
    const [otherActive, setOtherActive] = useState(false);
    const [checkboxesValue, setCheckboxesValue] = useState({});

    const handleChangeOther = (event, active) => {
        setOtherActive(active);
        const otherKey = otherValue || 'other';
        const extendedCheckboxes = {
            ...checkboxesValue,
            [otherKey]: active,
        };
        props.onChange(event, extendedCheckboxes);
    };

    const handleChangeInput = (event, value) => {
        setOtherValue(value);
        const otherKey = value || 'other';
        const extendedCheckboxes = {
            ...checkboxesValue,
            [otherKey]: otherActive,
        };
        props.onChange(event, extendedCheckboxes);
    };

    const handleChangeGroup = (event, checkboxes, checkbox) => {
        setCheckboxesValue(checkboxes);
        const otherKey = otherValue || 'other';
        const extendedCheckboxes = {
            ...checkboxes,
            [otherKey]: otherActive,
        };
        props.onChange(event, extendedCheckboxes);
    };

    return (
        <div>
            <SuiCheckboxGroup {...props} onChange={handleChangeGroup}>
                {props.children}
            </SuiCheckboxGroup>
            <StyledOtherOption>
                <SuiCheckbox key="other" name="other" label={OTHER_LABEL} onChange={handleChangeOther} />
            </StyledOtherOption>
            {otherActive && (
                <SuiTextInput
                    fullWidth
                    aria-label={questionLabel ? `${OTHER_LABEL} (${questionLabel})` : OTHER_LABEL}
                    className={`${baseClassName}__other-input`}
                    value={otherValue}
                    onChange={handleChangeInput}
                />
            )}
        </div>
    );
};

CheckboxIncludeOther.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
    onChange: PropTypes.func.isRequired,
    questionLabel: PropTypes.string,
};

CheckboxIncludeOther.defaultProps = {
    children: [],
    questionLabel: null,
};

export default CheckboxIncludeOther;
